import DisplayOnMobile from './DisplayOnMobile';

export default DisplayOnMobile;
